import React from "react";
import PropTypes from "prop-types";
import { HashLink } from "react-router-hash-link";
import styled from "styled-components";
import { color } from "src/styles/variables";

function getCrumbLink({ pathname, crumb }) {
  const endIndex = pathname.indexOf(crumb) + crumb.length;
  return pathname.substring(0, endIndex);
}

function getCrumbs({ pathname = "" }) {
  return pathname
    .split("/")
    .filter((crumb) => crumb)
    .map((crumb) => {
      return {
        path: getCrumbLink({ pathname, crumb }),
        text: crumb.replace(/-/g, " "),
      };
    });
}

function Breadcrumbs({ pathname, crumbs }) {
  const crumbsList = crumbs || getCrumbs({ pathname });

  if (crumbsList.length < 1) return null;

  return (
    <BreadcrumbList>
      {crumbsList.map((crumb, index) =>
        index === crumbsList.length - 1 ? (
          <BreadcrumbItem key={index}>{crumb.text}</BreadcrumbItem>
        ) : (
          <BreadcrumbItem key={index}>
            <HashLink to={crumb.path}>{crumb.text}</HashLink>
          </BreadcrumbItem>
        )
      )}
    </BreadcrumbList>
  );
}

Breadcrumbs.propTypes = {
  pathname: PropTypes.string,
  crumbs: PropTypes.array,
};

export default Breadcrumbs;

export const BreadcrumbList = styled.ul`
  margin: 20px 0;
`;

export const BreadcrumbItem = styled.li`
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  padding: 0;
  text-transform: capitalize;
  :not(:first-child):before {
    content: ">";
    display: inline-block;
    padding: 0 0.4em 0 0.3em;
  }
  & a {
    color: ${color.red};
  }
`;
